import { useEffect, useRef, useState } from 'preact/hooks';

import CardService from '../../services/card.service';

import CardNumberStep from '../../components/CardActivation/CardNumberStep';
import AppBar from '../../components/shared/AppBar/AppBar';
import useAndroidBackPress from '../../hooks/back.listener.hook';
import NavigationUtils from '../../utils/navigation.utils';
import { renderIf } from '../../utils/render.utils';
import LoadingScreen from '../../components/shared/LoadingScreen/LoadingScreen';
import useTranslation from '../../localization/i18n.context';
import { UrlEvent } from '../../sdk/url.event';
import useEventListener from '../../hooks/event.listener.hook';
import { AuthenticateEvent } from '../../sdk/authenticate.event';

export default function ResetPinPage({ organization, cardUid }) {
  const { t } = useTranslation();
  const [data, setData] = useState({
    cardNumber: '',
  });
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [error, setError] = useState(null);
  const backRef = useRef(null);
  const paramsRef = useRef({ ...data, organization, cardUid });

  useEffect(() => {
    paramsRef.current = { ...data, organization, cardUid };
  }, [data, organization, cardUid]);

  const handleInput = (key, value) => {
    const temp = { ...paramsRef.current, [key]: value };
    setData(temp);
  };

  const handleFormSubmit = e => {
    if (e) e.preventDefault();
    setLoadingScreen(true);

    CardService.setPin(
      paramsRef.current.organization,
      paramsRef.current.cardUid,
      {
        lastFourCardDigits: paramsRef.current.cardNumber,
      },
    )
      .then(body => {
        UrlEvent.intercept(
          body.resetPinUrl,
          [
            {
              regex: '.*',
              url: `${window.location.origin}${NavigationUtils.Routes.RESET_PIN_STATUS}?organization=${organization}&cardUid=${cardUid}&cardNumber=${paramsRef.current.cardNumber}`,
            },
          ],
          null,
          {
            headers: {
              token: body.token,
            },
          },
        );
      })
      .catch(() => {
        setLoadingScreen(false);
        setError(t('The numbers entered do not match the ones on your card'));
      });
  };

  const onAuthenticateResponse = eventData => {
    const { status } = eventData;

    if (status === AuthenticateEvent.Status.VERIFIED) {
      handleFormSubmit(); // Call form submit after authentication is verified
    }
  };

  useEventListener(
    onAuthenticateResponse,
    window.__CAAS__.events.authenticatePasscode,
  );

  const onContinueButtonClick = e => {
    e.preventDefault(); // Prevent the form from submitting without authentication
    AuthenticateEvent.authenticate();
  };

  useAndroidBackPress(backRef.current, () => {
    backRef.current.props.onClick();
  });

  return (
    <>
      <AppBar
        onBackClick={() => {
          NavigationUtils.back();
        }}
        onCloseClick={() => {
          NavigationUtils.endFlow();
        }}
        backRef={backRef}
        className="fixed-bar"
      />

      <form onSubmit={onContinueButtonClick}>
        <CardNumberStep
          value={data.cardNumber}
          onInput={handleInput}
          organizationCode={organization}
          error={error}
        />
      </form>
      {renderIf(loadingScreen, <LoadingScreen />)}
    </>
  );
}
